import { Map } from "immutable";
import ActionTypes from "./constants";

interface IEventUserPresenceInitialState {
  isOnline: boolean;
  liveUsers: string[];
  usersPerSpace: Map<string, string[]>;
}

export const initialState: IEventUserPresenceInitialState = {
  isOnline: false,
  liveUsers: [],
  usersPerSpace: Map<string, string[]>(),
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @typescript-eslint/default-param-last
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.RESET_PRESENCE_INFO:
      return initialState;
    case ActionTypes.SET_LIVE_USERS:
      return { ...state, liveUsers: action.payload.liveUsers };
    case ActionTypes.SET_USERS_PER_SPACE:
      return { ...state, usersPerSpace: action.payload.usersPerSpace };
    default:
      return state;
  }
};

export default reducer;
